import { TableHeadItemRecurse } from '../../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'De', flex: 1.5 },
  { title: 'Para', flex: 1.5 },
  { title: 'Solicitado via', flex: 0.8, orderValue: 'Source' },
  { title: 'Protocolo', flex: 1.2, orderValue: 'ProtocolNumber' },
  { title: 'Data de solicitação', orderValue: 'CreatedAt' },
  { title: 'Status', flex: 0.8, orderValue: 'CurrentStage' },
  { title: '', flex: 0.8 },
];
